import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { OverlayPanel } from "primereact/overlaypanel";
import { Button } from "primereact/button";
import { Carousel } from "primereact/carousel";
import Helpers from "../../../../../utils/helpers";

const GridPanel = (props: any) => {
  let { handelDialogbox } = props;
  var navigate = useNavigate();
  const [gridDatas, setGridDatas] = useState<any[]>([]);
  const responsiveOptions = [
    {
      breakpoint: "1199px",
      numVisible: 1,
      numScroll: 1,
    },
    {
      breakpoint: "991px",
      numVisible: 1,
      numScroll: 1,
    },
    {
      breakpoint: "767px",
      numVisible: 1,
      numScroll: 1,
    },
  ];

  useEffect(() => {
    if (props && props.filteredItems && props.filteredItems.length > 0) {
      setGridDatas(props.filteredItems);
    }
  }, [props]);
  const DetailsOverlay = (data: any) => {
    const selectDaysDpDown = useRef<any>(null);
    return (
      <>
        <i
          className="pi pi-ellipsis-v"
          style={{ fontSize: "1em", cursor: "pointer" }}
          onClick={(e) => selectDaysDpDown.current.toggle(e)}
        ></i>
        <OverlayPanel ref={selectDaysDpDown}>
          <Button
            onClick={() => {
              handelDialogbox(data.row);
            }}
          >
            Details
          </Button>
        </OverlayPanel>
      </>
    );
  };
  const productTemplate = (gridData: any) => {
    return (
      <>
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div className="card panel-box">
            <div className="card-header">
              <h6>{gridData.routeName}</h6>
              <div className="dropdown">
                <DetailsOverlay row={gridData} />
              </div>
            </div>
            <div className="card-body">
              <ol>
                <li>
                  <div className="list-title">Site Name</div>
                  <div className="list-value">{gridData?.siteName}</div>
                </li>
                <li>
                  <div className="list-title">Camera Operator</div>
                  <div className="list-value">{gridData?.cameraOperator}</div>
                </li>
                <li>
                  <div className="list-title">Customer</div>
                  <div className="list-value">{gridData?.customer}</div>
                </li>
                <li>
                  <div className="list-title">Total Observations</div>
                  <div className="list-value">
                    {gridData?.total_observations}
                  </div>
                </li>
                <li>
                  <div className="list-title">Total Target</div>
                  <div className="list-value">{gridData?.totalTarget}</div>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </>
    );
  };
  return (
    <>
      <Carousel
        value={gridDatas}
        numVisible={3}
        numScroll={1}
        responsiveOptions={responsiveOptions}
        itemTemplate={productTemplate}
      />
    </>
  );
};

export default GridPanel;
